import JQueryView, { on } from '../../../common/views/jqueryView';

export default class AboutPageView extends JQueryView {
  constructor() {
    super('#sb-site');

    this.scrollfunc();
    this.initCustomerVoiceSlider();
  }

  scrollfunc() {
    $(window).scroll(() => {
      const $floatingInview = $('.js-floating-inview');

      if (window.scrollY > 100) {
        $floatingInview.addClass('is-active');
      } else {
        $floatingInview.removeClass('is-active');
      }
    });
  }

  //スライダー
  initCustomerVoiceSlider() {
    const $slider = $('.js-slick-customer-voice');

    $slider.slick({
      infinite: true,
      arrows: true,
      dots: false,
      slidesToScroll: 1,
      variableWidth: true,

      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick',
        },
      ],
    });
  }

  //スマホ時のもっと見る
  @on({ event: 'click', selector: '.js-click-showmore' })
  customerVoiceShowMore(e: JQuery.ClickEvent) {
    const $btn = $(e.currentTarget);
    const $accordion = $('.js-accordion');

    if ($accordion.hasClass('is-closed')) {
      $btn.text('表示を減らす');
      $accordion.removeClass('is-closed');
    } else {
      $btn.text('さらに表示する');
      $accordion.addClass('is-closed');
    }
  }
}
